import React from 'react';
import GridOnOutlinedIcon from '@mui/icons-material/GridOnOutlined';
import eventFormatter from '#component/device/event-formatter';
import PreloaderComponent from '#component/preloader';
import { EmptyLogs } from '#component/warehouse/warehouse-log/empty-log';
import EventDescription from '#component/warehouse/warehouse-log/event-description';
import LogCard from '#component/general/log-card';
import { StyledList } from './styles';

/**
 * Renders cards with log info.
 * @returns {React.FC}
 */

const MobileView = props => {
  const { account, loading, error, logs } = props;

  if (error) {
    return <EmptyLogs />;
  }

  if (!logs.length && loading) {
    return <PreloaderComponent />;
  }

  return (
    logs.length > 0 ? (
      <StyledList isLoading={loading}>
        {logs.map((log, i) => (
          <LogCard
            key={i}
            log={log}
            account={account}
            icon={<GridOnOutlinedIcon />}
            EventDescriptionComponent={EventDescription}
            eventFormatter={eventFormatter}
          />
        ))}
      </StyledList>
    ) : (
      <EmptyLogs />
    )
  );
};

export default MobileView;
